import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "chevron-up-icon",
  "aria-label": "Chevron up icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.4697 5.96967C11.7626 5.67678 12.2374 5.67678 12.5303 5.96967L21.5303 14.9697C21.8232 15.2626 21.8232 15.7374 21.5303 16.0303C21.2374 16.3232 20.7626 16.3232 20.4697 16.0303L12 7.56066L3.53033 16.0303C3.23744 16.3232 2.76256 16.3232 2.46967 16.0303C2.17678 15.7374 2.17678 15.2626 2.46967 14.9697L11.4697 5.96967Z"
    }, null, -1)
  ])))
}
export default { render: render }